import { defineComponent } from 'vue';

import FaqItem from './FaqItem.class';

export default defineComponent({
	props: {
		question: String,
		answer: String
	},
	setup: (props: any) => {
		const component = new FaqItem();

		return {
			isOpened: component.isOpened,
			question: props.question,
			answer: props.answer,
			toggle: component.toggle.bind(component)
		};
	}
});
